import { Image, Page, Path, Svg, Text, View } from '@react-pdf/renderer';

import logo from '../../../assets/logos/appraisify/appraisify-blue.png';
import { fontStyles, pageStyles, coverPageStyles as styles } from '../styles.ts';
import { CoverPageProps } from '../types.ts';

export const CoverPage = ({
  subjectAddress,
  opinionOfMarketValue,
  totalCostToCure,
  propertyImage,
  intendedUsers,
  effectiveDate,
  shortPropertyType,
  inspectorType,
  appraisalType,
  includeTotalCostToCure,
  includeTotalRenovationBudget,
  includeOpinionOfAfterRepairValue,
  hasArvOption,
  totalRenovationBudget,
  opinionOfAfterRepairValue,
  estimatedROI,
  clientName,
  inspectionDate,
  valueType,
  inspectionData,
  appraisalReportDisclaimer,
}: CoverPageProps) => (
  <Page size="A4" style={pageStyles.page}>
    <View style={styles.page}>
      <View>
        <View style={styles.header}>
          <View style={styles.headerRow}>
            <Image src={logo} style={styles.headerLogo} />
            <Text style={styles.headerProductTypeTag}>{appraisalType}</Text>
          </View>
          <View style={styles.inspectionCheckboxes}>
            <View style={styles.inspectionCheckboxSection}>
              {inspectionData?.hasInspection ? (
                <Svg viewBox="0 0 16 16" width="16" height="16">
                  <Path
                    fill="#73A9EF"
                    d="M14.2222 0H1.77778C0.8 0 0 0.8 0 1.77778V14.2222C0 15.2 0.8 16 1.77778 16H14.2222C15.2 16 16 15.2 16 14.2222V1.77778C16 0.8 15.2 0 14.2222 0ZM6.85333 11.8133C6.7711 11.8957 6.67342 11.9611 6.56589 12.0057C6.45836 12.0503 6.34308 12.0733 6.22667 12.0733C6.11025 12.0733 5.99498 12.0503 5.88745 12.0057C5.77991 11.9611 5.68223 11.8957 5.6 11.8133L2.40889 8.62222C2.32659 8.53993 2.26131 8.44223 2.21678 8.33471C2.17224 8.22718 2.14931 8.11194 2.14931 7.99556C2.14931 7.87917 2.17224 7.76393 2.21678 7.65641C2.26131 7.54888 2.32659 7.45118 2.40889 7.36889C2.49118 7.28659 2.58888 7.22131 2.69641 7.17678C2.80393 7.13224 2.91917 7.10931 3.03556 7.10931C3.15194 7.10931 3.26718 7.13224 3.37471 7.17678C3.48223 7.22131 3.57993 7.28659 3.66222 7.36889L6.22222 9.92889L12.3378 3.81333C12.504 3.64713 12.7294 3.55376 12.9644 3.55376C13.1995 3.55376 13.4249 3.64713 13.5911 3.81333C13.7573 3.97954 13.8507 4.20495 13.8507 4.44C13.8507 4.67505 13.7573 4.90046 13.5911 5.06667L6.85333 11.8133Z"
                  />
                </Svg>
              ) : (
                <Text style={styles.inspectionCheckboxUnchecked} />
              )}
              <Text style={styles.inspectionCheckboxText}>Inspection</Text>
            </View>
            <View style={styles.inspectionCheckboxSection}>
              {inspectionData?.hasInspection ? (
                <Text style={styles.inspectionCheckboxUnchecked} />
              ) : (
                <Svg viewBox="0 0 16 16" width="16" height="16">
                  <Path
                    fill="#73A9EF"
                    d="M14.2222 0H1.77778C0.8 0 0 0.8 0 1.77778V14.2222C0 15.2 0.8 16 1.77778 16H14.2222C15.2 16 16 15.2 16 14.2222V1.77778C16 0.8 15.2 0 14.2222 0ZM6.85333 11.8133C6.7711 11.8957 6.67342 11.9611 6.56589 12.0057C6.45836 12.0503 6.34308 12.0733 6.22667 12.0733C6.11025 12.0733 5.99498 12.0503 5.88745 12.0057C5.77991 11.9611 5.68223 11.8957 5.6 11.8133L2.40889 8.62222C2.32659 8.53993 2.26131 8.44223 2.21678 8.33471C2.17224 8.22718 2.14931 8.11194 2.14931 7.99556C2.14931 7.87917 2.17224 7.76393 2.21678 7.65641C2.26131 7.54888 2.32659 7.45118 2.40889 7.36889C2.49118 7.28659 2.58888 7.22131 2.69641 7.17678C2.80393 7.13224 2.91917 7.10931 3.03556 7.10931C3.15194 7.10931 3.26718 7.13224 3.37471 7.17678C3.48223 7.22131 3.57993 7.28659 3.66222 7.36889L6.22222 9.92889L12.3378 3.81333C12.504 3.64713 12.7294 3.55376 12.9644 3.55376C13.1995 3.55376 13.4249 3.64713 13.5911 3.81333C13.7573 3.97954 13.8507 4.20495 13.8507 4.44C13.8507 4.67505 13.7573 4.90046 13.5911 5.06667L6.85333 11.8133Z"
                  />
                </Svg>
              )}
              <Text style={styles.inspectionCheckboxText}>No Inspection</Text>
            </View>
          </View>
        </View>

        <View style={{ margin: 56 }}>
          <Text style={fontStyles.h1}>Appraisal</Text>
          <Text style={fontStyles.h1}>Report</Text>
        </View>
      </View>

      <View style={{ flexDirection: 'row' }}>
        {propertyImage && (
          <Image
            src={propertyImage}
            style={[styles.subjectPropertyImage, { height: hasArvOption ? 305 : 250 }]}
          />
        )}

        <View style={styles.details}>
          <View style={styles.detail}>
            <Text style={[fontStyles.bodyRegularLight, fontStyles.uppercase]}>
              Property Location
            </Text>
            <Text style={fontStyles.bodyBold}>{subjectAddress}</Text>
          </View>
          {hasArvOption ? (
            <>
              {includeTotalRenovationBudget && (
                <View style={styles.detail}>
                  <Text style={[fontStyles.bodyRegularLight, fontStyles.uppercase]}>
                    Renovation Budget
                  </Text>
                  <Text style={fontStyles.bodyBold}>{totalRenovationBudget}</Text>
                </View>
              )}
              <View style={styles.detail}>
                <Text style={[fontStyles.bodyRegularLight, fontStyles.uppercase]}>
                  Opinion of As-Is Value
                </Text>
                <Text style={fontStyles.bodyBold}>{opinionOfMarketValue}</Text>
              </View>
              {includeOpinionOfAfterRepairValue && (
                <View style={styles.detail}>
                  <Text style={[fontStyles.bodyRegularLight, fontStyles.uppercase]}>
                    Opinion of After-Repair Value
                  </Text>
                  <Text style={fontStyles.bodyBold}>{opinionOfAfterRepairValue}</Text>
                </View>
              )}
              {includeOpinionOfAfterRepairValue && (
                <View style={styles.detail}>
                  <Text style={[fontStyles.bodyRegularLight, fontStyles.uppercase]}>
                    Estimated Return on Investment
                  </Text>
                  <Text style={fontStyles.bodyBold}>{estimatedROI}</Text>
                </View>
              )}
              {clientName && (
                <View style={styles.detail}>
                  <Text style={[fontStyles.bodyRegularLight, fontStyles.uppercase]}>
                    Client Name
                  </Text>
                  <Text style={fontStyles.bodyBold}>{clientName}</Text>
                </View>
              )}
            </>
          ) : (
            <>
              <View style={styles.detail}>
                <Text style={[fontStyles.bodyRegularLight, fontStyles.uppercase]}>
                  Opinion of Market Value
                </Text>
                <Text style={fontStyles.bodyBold}>{opinionOfMarketValue}</Text>
              </View>
              {includeTotalCostToCure && (
                <View style={styles.detail}>
                  <Text style={[fontStyles.bodyRegularLight, fontStyles.uppercase]}>
                    Total Cost to Cure
                  </Text>
                  <Text style={fontStyles.bodyBold}>{totalCostToCure}</Text>
                </View>
              )}
              {intendedUsers && (
                <View style={styles.detail}>
                  <Text style={[fontStyles.bodyRegularLight, fontStyles.uppercase]}>
                    Intended User(s)
                  </Text>
                  <Text style={fontStyles.bodyBold}>{intendedUsers}</Text>
                </View>
              )}
            </>
          )}
          <View style={styles.detail}>
            <Text style={[fontStyles.bodyRegularLight, fontStyles.uppercase]}>Effective Date</Text>
            <Text style={fontStyles.bodyBold}>{effectiveDate}</Text>
          </View>
          {inspectionDate && (
            <View style={styles.detail}>
              <Text style={[fontStyles.bodyRegularLight, fontStyles.uppercase]}>
                Inspection Date
              </Text>
              <Text style={fontStyles.bodyBold}>{inspectionDate}</Text>
            </View>
          )}
        </View>
      </View>

      <View style={styles.tags}>
        {appraisalType.length > 0 && (
          <View style={styles.tag}>
            <Text>Property Type</Text>
            <Text style={styles.tagValue}>{shortPropertyType}</Text>
          </View>
        )}
        {inspectorType.length > 0 && (
          <View style={styles.tag}>
            <Text>Inspector Type</Text>
            <Text style={styles.tagValue}>{inspectorType}</Text>
          </View>
        )}
        {valueType.length > 0 && (
          <View style={styles.tag}>
            <Text>Valuation Type</Text>
            <Text style={styles.tagValue}>{valueType}</Text>
          </View>
        )}
      </View>
      {appraisalReportDisclaimer && (
        <View style={styles.disclaimer}>
          <Text style={[fontStyles.bodyItalic, fontStyles.accent]}>
            {appraisalReportDisclaimer}
          </Text>
        </View>
      )}
    </View>
  </Page>
);
